import { reskinStyles } from 'core/components/theme/theme-variant';
import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  accountCard: {
    padding: theme.spacing(8),
    position: 'relative',
    overflowWrap: 'anywhere'
  },
  buttonContainer: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: '100%'
  },
  inviterLink: {
    color: theme.colors.action_text,
    ...reskinStyles(theme, theme.actionStyles.link)
  },
  secondaryPhoneContainer: {
    border: `3px solid ${theme.colorPalette.white}`,
    borderRadius: 3,
    padding: '10px 20px 10px 20px',
    margin: '15px 0px',
    // Reskin: a beige inset panel; a white border can't frame anything on the new look's white card.
    ...reskinStyles(theme, theme.cardStyles.inset)
  },
  affinityRow: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    gap: theme.spacing(2)
  },
  affinityLink: {
    color: theme.colors.action_text,
    textDecoration: 'none',
    fontWeight: 600,
    whiteSpace: 'nowrap',
    paddingBottom: theme.spacing(2),
    ...reskinStyles(theme, theme.actionStyles.link)
  }
});

export default makeStyles(styles);
